module.exports = __webpack_public_path__ + "img/17852_L.456a5090.png";